import React, { PropsWithChildren } from 'react';

import classes from './CheckoutContainer.module.scss';

const CheckoutContainer = ({ children }: PropsWithChildren) => {
  return <div className={classes.container}>{children}</div>;
};

export { CheckoutContainer };
